import { Box, Typography, ToggleButtonGroup, ToggleButton } from "@mui/material";
import CONSTANTS from '../../utils/constants/UIConstants';
const LABS = [
  { id: 1, title: "Industrial Lab", subtitle: "Baltimore MD" },
  { id: 2, title: "Food Lab", subtitle: "Fredericton NB" },
];

interface SelectableCardGroupProps {
  value: number | null;
  onChange: (labId: number) => void;
}

export default function SelectableCardGroup({ value, onChange }: SelectableCardGroupProps) {
  return (
    <>
    <Box sx={{ maxWidth: 414, mb: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Select lab *
      </Typography>

      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => newValue !== null && onChange(newValue)}
        sx={{
          width: "100%",
          '& .MuiToggleButton-root': {
            flex: 1,
            textTransform: 'none',
            alignItems: 'flex-start',
            flexDirection: 'column',
            padding: '6px 12px',
            fontSize: 16,
            borderRight: '0px',
          },
          '& .MuiToggleButton-root + .MuiToggleButton-root': {
            borderLeft: '1px solid',
            borderLeftColor: 'divider',
            borderRight: '1px solid',
            borderRightColor: 'divider',
          },
          '& .Mui-selected': {
            backgroundColor: theme => CONSTANTS.PRIMARY_COLOR_BLUE + ' !important',
          },
          '& .Mui-selected .MuiTypography-root': {
            color: theme => CONSTANTS.PRIMARY_COLOR_MATCH_WHITE,
          },
        }}
      >
        {LABS.map((lab) => (
          <ToggleButton key={lab.id} value={lab.id}>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: 1.3,
                color: '#2C2C2C',
              }}
            >
              {lab.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {lab.subtitle}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
    <Typography
      variant="caption"
      color="textSecondary"
      display="block"
      sx={{ mt: 1, mb: 1, width: 0, minWidth: '100%' }}
    >
      Lab selection determines which fields and analyses appear below.
    </Typography>
    </>
  );
}